import IobLineItem from "../Domain/IobLineItem";
import serviceHelper from "../Helpers/serviceHelper";
import AuthService from "./authService";
import SearchParams from "../Elements/SearchParams";
import IobLineItemSearchParams from "../Contents/Operations/IOB/IobLineItemSearchParams";

export default class IobLineItemService {
    static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
        const authService = AuthService.getInstance();
        let url = 'api/IobLineItem/GetAllBySearchingAsync/?';

        const searchParams = new SearchParams(searchItem, IobLineItemSearchParams, orderById, orderDir, pageNumber, numberOfElements);

        url += `searchParams=${searchParams.serializeForBackendCall()}`;
        url += `&clearCache=${clearCache}`;

        return authService.CallBackendFunction(url);
    }

    static ConvertDBItemList(items) {
        const convertedItems = [];

        if (items !== null) {
          items.forEach((item) => {
            const newItem = new IobLineItem(item);
            convertedItems.push(newItem);
          });
        }

        return convertedItems;
    }

    static GetById(id) {
        const authService = AuthService.getInstance();
        const url = `/api/Iob/GetByIdAsync/${id}?clearCache=false`;
        return authService.CallBackendFunction(url);
    }

    static GetInvoiceById(item) {
        return AuthService.getInstance().CallBackendFunction(
          `/api/Iob/GetInvoiceById?searchItem=${JSON.stringify(item)}&clearCache=false`
        );
    }

    static UpsertIobLineItem(item) {
        item = serviceHelper.ConvertAllPropertyToString(item)

        const JSONItem = JSON.stringify(item);

        let url = "/api/IobLineItem/PostIobLineItemAsync";

        if (item["IoblineItemId"] !== "") {
            url = "/api/IobLineItem/EditIobLineItemAsync";

            return AuthService.getInstance()
                .CallBackendFunctionPut(url, JSONItem)
        }

        return AuthService.getInstance()
            .CallBackendFunctionPost(url, JSONItem)
    }
}